module.exports = __webpack_public_path__ + "img/HH-small.90e6e60a.png";